import React from 'react';
import PropTypes from 'prop-types';
import useCheckTwoDepartments from '../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { ACCOUNTS, SUPER_ADMIN } from '../../../../../utils/departments/helpers';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import AccountsNavBar from '../../../../layouts/accounts/AccountsNavBar';
import AccountsReverseFirsTransactionsBody from './AccountsReverseFirsTransactionsBody';

const AccountsReverseFirsTransactions = ({ history }) => {
  useCheckTwoDepartments(`${ACCOUNTS}`, `${SUPER_ADMIN}`, history);
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AccountsNavBar currentPage="Firs Reverse Transactions" position={firstName} />
        <AccountsReverseFirsTransactionsBody />
      </main>
    </div>
  );
};

export default AccountsReverseFirsTransactions;
